export default "__VITE_ASSET__CTrRZTcB__"